export default function ensureMinimumWithDuplicates<T>(
  partners: T[],
  minimum: number = 6,
): T[] {
  if (!partners)
    throw Error("Array is nullish, are you fetching and not awaiting?");

  const extendedPartners: T[] = [];

  // Keep duplicating the array until the length is at least the minimum
  while (extendedPartners.length < minimum) {
    extendedPartners.push(...partners);
  }

  return extendedPartners;
}
